import React from "react";

const Footer = () => (
  <footer className="bg-light p-3 text-center">
    <div className="logo" />
    <p className="mb-2">
      KuzFit Copyright 2025.
    </p>
    <p className="mb-0">
      <a href="https://www.kuzfit.com">Privacy Policy</a>
    </p>
  </footer>
);

export default Footer;
